import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

function ProtectedRoute({ children, hasPermission }) {
  const isLoggedIn = useSelector((state) => state.authReducer.isLoggedIn);
  const isOnboarded = useSelector(
    (state) => state.accountReducer.currentUser?.user?.onboarded
  );
  const isPasswordExpired = useSelector(
    (state) => state.accountReducer.currentUser?.password_expired
  );
  const location = useLocation();

  if (!isLoggedIn) {
    if (location.pathname === '/change-password') {
      return <Navigate to='/login' replace />;
    }
    return (
      <Navigate
        to={`/login?callback=${location.pathname}`}
        state={{ from: location }}
        replace
      />
    );
  }

  if (!hasPermission) {
    return <Navigate to='/unauthorized' replace />;
  }

  if (isOnboarded && location?.pathname === '/onboarding') {
    return <Navigate to='/' replace />;
  }

  if (!isOnboarded && location?.pathname !== '/onboarding') {
    return <Navigate to='/onboarding' replace />;
  }

  if (isPasswordExpired && location?.pathname !== '/change-password') {
    return (
      <Navigate to='/change-password' state={{ from: location }} replace />
    );
  }

  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.any,
  hasPermission: PropTypes.bool,
};

export default memo(ProtectedRoute);
